import * as React from 'react'

function QuestionLabel({ htmlFor, children }) {
  return (
    <label className="mb-0 flex mb-1" htmlFor={htmlFor}>
      {children}
    </label>
  )
}

export default QuestionLabel
